import React, {
  CSSProperties,
  FC, useEffect, useRef,
} from 'react';
import {
  RowRight, UserContent,
} from '../../../Styles';
import { lang } from '../../../../../../../lib/utils/utils';

const UserReply: FC<Props> = ({
  children,
  style,
  langZh,
  langEn,
}) => {
  const enRef = useRef<any>();
  const zhRef = useRef<any>();

  useEffect(() => {
    const interval = setInterval(() => {
      if (enRef.current && zhRef.current) {
        const langValue = lang(langEn, langZh);
        if (langValue === langEn) {
          enRef.current.style.display = 'block';
          zhRef.current.style.display = 'none';
        }
        else {
          enRef.current.style.display = 'none';
          zhRef.current.style.display = 'block';
        }
      }
    }, 100);

    return () => clearInterval(interval);
  }, [langZh, langEn]);

  return (
    <RowRight>
      <UserContent style={{ fontFamily: lang('Inter-Regular, Inter', 'PingFangSC-Regular, PingFang SC'), ...style }}>
        {children}
        <div style={{ display: 'none', fontFamily: 'Inter-Regular, Inter' }} ref={enRef}>
          {langEn}
        </div>
        <div style={{ display: 'none', fontFamily: 'PingFangSC-Regular, PingFang SC' }} ref={zhRef}>
          {langZh}
        </div>
      </UserContent>
    </RowRight>
  );
};

export interface Props {
  children?: React.ReactNode;
  langZh: React.ReactNode;
  langEn: React.ReactNode;
  style?: CSSProperties;
}

export default UserReply;
